const cards = [
  {
    id: 'singer',
    title: '歌手 2024',
    tag: '音乐竞技',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '华语乐坛顶级歌手同台竞演，巅峰对决震撼开唱，每一期都是视听盛宴。',
    img: 'https://readdy.ai/api/search-image?query=music%20singing%20competition%20stage%20with%20dramatic%20golden%20spotlights%20and%20singer%20silhouette%2C%20grand%20concert%20atmosphere%2C%20warm%20amber%20lighting%2C%20professional%20stage%20production%2C%20cinematic%20photography%2C%20editorial%20style&width=700&height=440&seq=card-singer&orientation=landscape',
  },
  {
    id: 'running',
    title: '奔跑吧',
    tag: '户外真人秀',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '国民级户外竞技真人秀，明星嘉宾趣味挑战，笑料不断欢乐无限。',
    img: 'https://readdy.ai/api/search-image?query=outdoor%20game%20show%20with%20colorful%20team%20activities%20in%20bright%20sunlight%2C%20group%20of%20people%20playing%20fun%20challenges%2C%20vibrant%20park%20setting%2C%20warm%20natural%20lighting%2C%20entertainment%20photography&width=700&height=440&seq=card-running&orientation=landscape',
  },
  {
    id: 'talk-show',
    title: '脱口秀大会',
    tag: '脱口秀',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '爆笑脱口秀竞技节目，犀利吐槽与幽默段子轮番上演，承包你的笑点。',
    img: 'https://readdy.ai/api/search-image?query=stand-up%20comedy%20stage%20with%20spotlight%20on%20microphone%2C%20intimate%20comedy%20club%20atmosphere%2C%20brick%20wall%20background%2C%20warm%20stage%20lighting%2C%20entertainment%20venue%2C%20editorial%20photography&width=700&height=440&seq=card-talk-show&orientation=landscape',
  },
  {
    id: 'life',
    title: '向往的生活',
    tag: '慢综艺',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '田园生活慢综艺，明星嘉宾远离喧嚣回归自然，感受质朴生活的美好。',
    img: 'https://readdy.ai/api/search-image?query=peaceful%20countryside%20farmhouse%20with%20warm%20sunlight%20and%20green%20gardens%2C%20rustic%20wooden%20table%20with%20fresh%20food%2C%20cozy%20rural%20lifestyle%20scene%2C%20natural%20golden%20hour%20lighting%2C%20editorial%20photography&width=700&height=440&seq=card-life&orientation=landscape',
  },
  {
    id: 'escape',
    title: '密室大逃脱',
    tag: '解谜挑战',
    tagColor: 'bg-accent-100 text-accent-700',
    desc: '沉浸式密室逃脱体验，烧脑谜题与团队协作，紧张刺激又趣味十足。',
    img: 'https://readdy.ai/api/search-image?query=mysterious%20escape%20room%20with%20dim%20warm%20lighting%20and%20puzzle%20elements%2C%20themed%20room%20with%20clues%20and%20locks%2C%20immersive%20atmosphere%2C%20cinematic%20suspense%20style%2C%20golden%20amber%20accents&width=700&height=440&seq=card-escape&orientation=landscape',
  },
  {
    id: 'dance',
    title: '这！就是街舞',
    tag: '舞蹈竞技',
    tagColor: 'bg-primary-100 text-primary-700',
    desc: '顶尖街舞选手激烈角逐，炸裂地板动作与创意编舞，街舞文化视觉盛宴。',
    img: 'https://readdy.ai/api/search-image?query=street%20dance%20battle%20stage%20with%20dynamic%20spotlights%20and%20dancer%20in%20motion%2C%20urban%20dance%20competition%20atmosphere%2C%20energetic%20performance%2C%20dramatic%20warm%20lighting%2C%20editorial%20style&width=700&height=440&seq=card-dance&orientation=landscape',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热门综艺推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            全网热播综艺一网打尽，口碑与热度双重保障
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-xl overflow-hidden transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={`极速影院${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                <span
                  className={`absolute top-3 left-3 px-2.5 py-1 rounded-lg text-[11px] font-bold ${card.tagColor}`}
                >
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-950 font-heading">{card.title}</h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="text-[11px] text-foreground-500">
                    <i className="ri-eye-line mr-1"></i>
                    更新至最新
                  </span>
                  <span className="text-[11px] text-primary-600 font-semibold">
                    <i className="ri-play-circle-line mr-1"></i>
                    立即观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}